import StrapiContent from 'components/tailgrids-ui/strapi';
import React from 'react';

const StrapiContentTastic = ({ data }) => {
  return <StrapiContent {...data} />;
};

export default StrapiContentTastic;
